<template>
  <div class="app-personal-data-form">
    <SimonModal
      :is-visible="showModal"
      @hide="back"
      id="change-customer-data-modal"
      disabled-close
      hidden-close-button
      @shown="onModalShown"
      show-footer-buttons
      @btnLeft="back"
      @btnRight="next"
      size="large"
      btn-right-title="Speichern"
    >
      <template v-slot:modalTitle>
        <h3><slot name="headerModal"></slot></h3>
      </template>
      <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
      <div class="form-wrapper">
        <b-form
          :id="'form' + _uid"
          :novalidate="true"
          class="personal-data-input-form"
          data-form-checkout-personal-data-input
          ref="form">
          <div class="form-row">
            <LabeledTextInput
              name="firstName"
              :model.sync="currentCustomer_.firstName"
              ref="nestedInputFirstName"
              :disabled=true
            >
              <template v-for="slot in possibleChildSlotsFor('FirstName')" v-slot:[`${slot.child}`]>
                <slot :name="`${slot.parent}`"></slot>
              </template>
            </LabeledTextInput>
            <LabeledTextInput
              name="lastName"
              :model.sync="currentCustomer_.lastName"
              ref="nestedInputLastName"
              :disabled=true
            >
              <template v-for="slot in possibleChildSlotsFor('LastName')" v-slot:[`${slot.child}`]>
                <slot :name="`${slot.parent}`"></slot>
              </template>
            </LabeledTextInput>
            <BirthdateInputValidation
              ref="nestedInputBirthDate"
              :date.sync="currentCustomer.birthDate"
              :disabled=true
              :mandatory=false
            >
              <template v-for="slot in possibleChildSlotsFor('BirthDate')" v-slot:[`${slot.child}`]>
                <slot :name="`${slot.parent}`"></slot>
              </template>
            </BirthdateInputValidation>
          </div>
          <div class="form-row">
            <LabeledTextInput
              name="street"
              :model.sync="currentCustomer_.address.street"
              :invalid.sync="invalid.currentCustomer_.street"
              :validation="validations.currentCustomer_.address.street"
              width="66"
              ref="nestedInputStreet"
              :mandatory="true"
            >
              <template v-for="slot in possibleChildSlotsFor('Street')" v-slot:[`${slot.child}`]>
                <slot :name="`${slot.parent}`"></slot>
              </template>
            </LabeledTextInput>
            <LabeledTextInput
              name="houseNumber"
              :model.sync="currentCustomer_.address.houseNumber"
              :invalid.sync="invalid.currentCustomer_.houseNumber"
              :validation="validations.currentCustomer_.address.houseNumber"
              ref="nestedInputHouseNumber"
              :mandatory="true"
            >
              <template v-for="slot in possibleChildSlotsFor('HouseNumber')" v-slot:[`${slot.child}`]>
                <slot :name="`${slot.parent}`"></slot>
              </template>
            </LabeledTextInput>
          </div>
          <div class="form-row">
            <LabeledTextInput
              name="zip"
              :model.sync="currentCustomer_.address.zip"
              :invalid.sync="invalid.currentCustomer_.zip"
              :validation="validations.currentCustomer_.address.zip"
              :formatter="zipFormatter()"
              width="33"
              ref="nestedInputZip"
              :mandatory="true"
            >
              <template v-for="slot in possibleChildSlotsFor('Zip')" v-slot:[`${slot.child}`]>
                <slot :name="`${slot.parent}`"></slot>
              </template>
            </LabeledTextInput>
            <LabeledTextInput
              name="city"
              :model.sync="currentCustomer_.address.city"
              :invalid.sync="invalid.currentCustomer_.city"
              :validation="validations.currentCustomer_.address.city"
              :formatter="formatterCharFilterOnlyAplha"
              ref="nestedInputAddressCity"
              :mandatory="true"
            >
              <template v-for="slot in possibleChildSlotsFor('City')" v-slot:[`${slot.child}`]>
                <slot :name="`${slot.parent}`"></slot>
              </template>
            </LabeledTextInput>
          </div>
          <div class="form-row">
            <LabeledTextInput
              name="supplement"
              :model.sync="currentCustomer_.address.supplement"
              ref="nestedInputSupplement"
            >
              <template v-for="slot in possibleChildSlotsFor('Supplement')" v-slot:[`${slot.child}`]>
                <slot :name="`${slot.parent}`"></slot>
              </template>
            </LabeledTextInput>
          </div>
          <div class="form-row">
            <LabeledTextInput
              name="email"
              :model.sync="currentCustomer_.email"
              :invalid.sync="invalid.currentCustomer_.email"
              :validation="validations.currentCustomer_.email"
              ref="nestedInputEmail"
              :mandatory="true"
            >
              <template v-for="slot in possibleChildSlotsFor('Email')" v-slot:[`${slot.child}`]>
                <slot :name="`${slot.parent}`"></slot>
              </template>
            </LabeledTextInput>
          </div>
          <div class="form-row">
            <LabeledPhoneNumberInput
              name="alternativePhone"
              :model.sync="currentCustomer_.alternativePhone"
              ref="nestedInputPhone"
            >
              <template v-for="slot in possibleChildSlotsFor('AlternativePhone')" v-slot:[`${slot.child}`]>
                <slot :name="`${slot.parent}`"></slot>
              </template>
            </LabeledPhoneNumberInput>
          </div>
        </b-form>
      </div>
    </SimonModal>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import isValid from '@/mixins/validators/isValid'
import date from '@/mixins/validators/date'
import syncProperty from '@/mixins/syncProperty'
import { maxLength, required } from 'vuelidate/lib/validators'
import emailValidator from '@/mixins/validators/emailValidator'
import logout from '@/mixins/logout'
import transaction from '@/mixins/transaction'
import { isValidPhoneExtIfNotEmpty } from '@/mixins/validators/phone'
import validationFlow from '@/mixins/validators/validationFlow'
import formatterCharFilterOnlyAplha from '@/mixins/formatters/inputFormatter'
import { mapActions } from 'vuex'
import SimonModal from '@/components/modal/SimonModal.vue'
import LabeledTextInput from '@/components/forms/LabeledTextInput.vue'
import BirthdateInputValidation from '@/components/forms/LabeledBirthdateInput.vue'
import LabeledPhoneNumberInput from '@/components/forms/LabeledPhoneNumberInput.vue'

const zipValidator = /^\d{5}$/
const isValidZipCode = (v) => zipValidator.test(v)
const houseNoValidator = /^(\d{1,5})$|^(\d{1,4}([a-zA-Z]))$|^(((\d{1,5})|(\d{1,4}([a-zA-Z])))-((\d{1,5})|(\d{1,4}([a-zA-Z]))||([a-zA-Z])))$/
const isValidHouseNo = (v) => houseNoValidator.test(v)

export const stepName = 'changePersonalData'

export default {
  name: 'CustomerFormModal',
  data () {
    return {
      loadedCurrentCustomer: false,
      invalid: {
        currentCustomer_: {
          email: null,
          alternativePhone: null,
          street: null,
          houseNumber: null,
          zip: null,
          city: null
        }
      },
      validations: {
        currentCustomer_: {
          email: {
            required
          },
          alternativePhone: {
            isValidPhoneExtIfNotEmpty
          },
          address: {
            street: {
              required,
              maxLength: maxLength(50)
            },
            houseNumber: {
              required,
              maxLength: maxLength(9),
              isValidHouseNo
            },
            zip: {
              required,
              isValidZipCode
            },
            city: {
              required,
              maxLength: maxLength(50)
            },
            supplement: {
              maxLength: maxLength(50)
            }
          }
        }
      }
    }
  },
  components: {
    LabeledPhoneNumberInput,
    BirthdateInputValidation,
    LabeledTextInput,
    SimonModal
  },
  props: {
    max50: {
      type: Number,
      default: 50
    },
    max9: {
      type: Number,
      default: 9
    },
    disableChangeNameAndBirthdate: {
      type: Boolean,
      default: true
    },
    currentCustomer: {
      type: Object
    },
    showToast: {
      type: Boolean,
      default: true
    }
  },
  mixins: [
    transaction('personalData'),
    validationMixin,
    isValid,
    date,
    emailValidator,
    logout,
    syncProperty('show', 'showModal'),
    syncProperty('currentCustomer', 'currentCustomer_'),
    validationFlow,
    formatterCharFilterOnlyAplha
  ],
  computed: {
    formInvalid: function () {
      return Object.entries(this.invalid.currentCustomer_)
        .map(([key, value]) => value)
        .some((value) => value === true)
    }
  },
  methods: {
    ...mapActions('personalDataChange', [
      'changePersonalData'
    ]),
    onModalShown () {
      this.currentCustomer_ = this.currentCustomer
    },
    forceValidationOnNestedInputs () {
      Object.entries(this.$refs).forEach(([key, comp]) => {
        if (/^nestedInput/.test(key) && comp !== undefined) {
          comp.vflowForceFeedback()
        }
      })
    },
    next () {
      this.forceValidationOnNestedInputs()

      if (!this.formInvalid) {
        this.startLoader()

        this.changePersonalData(this.currentCustomer_)
          .then((response) => {
            if (response === 'success') {
              this.showModal = false
              if (this.showToast) {
                this.successToast('Ihre Daten wurden erfolgreich geändert')
              }
              this.$emit('after-success')
            }
            this.loading_ = false
          })
          .catch(() => {
            this.loading_ = false
            throw new Error('technical failed')
          })
          .finally(() => {
            this.stopLoader()
          })
      } else {
        // Ensure live feedback for validation errors
        this.vFlowGetFirstErrorElementName().then((result) => {
          const data = {
            type: 'validation',
            message: 'required field missing',
            location: result + ' - unknown'
          }
          if (typeof window.trackingNS?.track?.tracking === 'function') {
            window.trackingNS.track.tracking('error', data)
          }
        })
      }
    },
    back () {
      this.$emit('cancel')
    },
    zipFormatter () {
      return (v) => v.replace(/[^\d]/g, '').substring(0, 5)
    }
  }
}
</script>
